import { render, staticRenderFns } from "./UserPersonalCardInfo.vue?vue&type=template&id=357dd753&"
import script from "./UserPersonalCardInfo.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports